export default {
  title: {
    id: 'hc_search_search_faq_articles',
    defaultMessage: 'Search our FAQ articles',
  },
  searchLabel: {
    id: 'hc_search_try_something_like',
    defaultMessage: 'How can we help?',
  },
}
